import { useCallback } from 'react';

import { useMytaverseEvent } from '@core/dashboard/providers';

export const useIsAIEnabledForEvent = () => {
  const { currentEventId, currentEvent } = useMytaverseEvent();

  return useCallback(() => {
    return !!(
      currentEventId &&
      currentEvent?.settings?.aiEnabled &&
      currentEvent?.settings?.aiVirtualAssistantName === 'Noa'
    );
  }, [currentEventId, currentEvent?.settings]);
};

// "Ask Me Anything" (free-form Q&A) is enabled by default; treat an absent
// setting as enabled and only disabled when explicitly set to false.
export const useIsAskMeAnythingEnabledForEvent = () => {
  const { currentEvent } = useMytaverseEvent();

  return useCallback(() => {
    return currentEvent?.settings?.aiAMAEnabled !== false;
  }, [currentEvent?.settings]);
};
